module.exports = __webpack_public_path__ + "static/img/z4.d04327ed.png";